module.exports = __webpack_public_path__ + "static/img/1.9835d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1.png
// module id = KZ+R
// module chunks = 0